export default __webpack_public_path__ + "static/media/icon-key-dark.128bc6ab.svg";